import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { BaseFormField, TextInput } from '@forthbridge/forms';

import { ModalType } from '@core/models/modal.types';
import { ModalService } from '@core/services/modal.service';

import { StatePickerModal } from '../../modals/state-picker/state-picker.modal';

/**
 * A state picker form field that opens a modal for state selection.
 * Displays as a text input that opens the StatePickerModal when clicked.
 */
@Component({
  selector: 'app-state-picker-field',
  template: `
    <div
      class="cursor-pointer"
      (click)="openPicker()"
    >
      <lib-text-input
        [formControl]="control!"
        [label]="label"
      />
    </div>
  `,
  imports: [TextInput],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatePickerField extends BaseFormField<string> {
  private readonly modalService = inject(ModalService);

  protected async openPicker(): Promise<void> {
    if (!this.control || this.isDisabledState) return;

    const currentValue = this.control.value ?? 'Texas';

    const result = await this.modalService.openModal(
      StatePickerModal,
      { selectedState: currentValue },
      ModalType.BOTTOM,
    );

    if (result) {
      this.control.setValue(result as string);
    }
  }
}
